module.exports = __webpack_public_path__ + "static/media/vector-selected.e561a224.svg";